/*====================================================
/* GALLERY SLIDER
/*====================================================*/
function GallerySliderInit() {
  const thumbnailElement = document.querySelector(".js-gallery-image-thumbnails");
  const displayElement = document.querySelector(".js-gallery-image-featured");

  // Check if the thumbnail element exists
  let gallery_thumbnails = null;

  if (thumbnailElement) {
    thumbnailElement.style.marginTop = "10px";

    gallery_thumbnails = new Swiper(thumbnailElement, {
      centerInsufficientSlides: thumbnailElement.getAttribute("data-center"),
      spaceBetween: 10,
      slidesPerView: thumbnailElement.getAttribute("data-slides"),
      navigation: {
        nextEl: ".rt-swiper-gallery .swiper-button-next",
        prevEl: ".rt-swiper-gallery .swiper-button-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: thumbnailElement.getAttribute("data-slides-md"),
        },
      },
    });
  }

  // Check if the display element exists and initialize Swiper
  if (displayElement) {
    const autoPlay = displayElement.getAttribute("data-autoplay");
    const delay = parseInt(displayElement.getAttribute("data-autoplay-delay"), 10) || 7; // Default to 7 seconds

    const gallery_display = new Swiper(displayElement, {
      autoHeight: true,
      spaceBetween: 10,
      autoplay: {
        delay: autoPlay ? delay * 1000 : 86400 * 1000,
      },
      pagination: {
        el: ".rt-swiper-gallery .swiper-pagination",
        type: "fraction",
      },
      // Only set thumbs if the thumbnail swiper was initialized
      thumbs: gallery_thumbnails ? { swiper: gallery_thumbnails } : {},
    });
  }
}
document.addEventListener("DOMContentLoaded", GallerySliderInit);
